import { LayeredLight } from 'survey-core/themes';

/**
 * Brand theme for all SurveyJS renderings (public page, in-app modal,
 * admin preview). LayeredLight gives the same visual language as the rest
 * of the app — white cards with soft shadows on an off-white background —
 * and the variables below carry the app's primary blue palette (mirroring
 * the :root overrides in index.css, which applyTheme would otherwise replace).
 */
const surveyTheme = {
    ...LayeredLight,
    cssVariables: {
        ...LayeredLight.cssVariables,
        '--sjs-primary-backcolor': '#5A7CDE',        /* primary */
        '--sjs-primary-backcolor-dark': '#4A66B6',   /* primary-dark (hover) */
        '--sjs-primary-backcolor-light': '#EFF2FC',  /* primary-tint */
        '--sjs-primary-forecolor': '#ffffff',
        '--sjs-general-backcolor-dim': '#F6F6F6',    /* app main background */
        '--sjs-corner-radius': '12px',               /* matches rounded-xl cards */
        '--sjs-font-family': 'inherit',
    },
};

export default surveyTheme;
